var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../base";
var FooterText = /** @class */ (function (_super) {
    __extends(FooterText, _super);
    function FooterText(text) {
        var _this = _super.call(this) || this;
        var footerText = document.createElement('div');
        footerText.id = 'js_aigo_bot_footer_text';
        footerText.innerHTML = text;
        footerText.style.paddingTop = '12px';
        footerText.style.paddingBottom = '12px';
        footerText.style.textAlign = 'center';
        footerText.style.paddingLeft = '20%';
        footerText.style.paddingRight = '20%';
        _this.self = footerText;
        return _this;
    }
    return FooterText;
}(Base));
export { FooterText };
